// src/shared/ui/Checkbox.jsx
import React, { useId } from 'react';

import styles from './Checkbox.module.css';

/**
 * Checkbox - Casilla de verificación con check blanco
 *
 * @param {boolean} checked - Estado marcado
 * @param {function} onChange - Callback al cambiar
 * @param {string} label - Etiqueta del checkbox
 * @param {boolean} disabled - Deshabilitado
 * @param {boolean|string} error - Estado de error o mensaje de error
 * @param {string} helper - Texto de ayuda
 * @param {string} id - ID único (autogenerado si no se pasa)
 */
export default function Checkbox({
  checked = false,
  onChange,
  label,
  disabled = false,
  error = false,
  helper,
  id: externalId,
  className = '',
  ...rest
}) {
  const autoId = useId();
  const id = externalId || autoId;
  const helperId = `${id}-helper`;
  const errorId = `${id}-error`;

  const classNames = [
    styles.checkbox,
    disabled ? styles.disabled : '',
    error ? styles.error : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames}>
      <label htmlFor={id} className={styles.wrapper}>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={styles.input}
          aria-describedby={
            [error ? errorId : null, helper ? helperId : null].filter(Boolean).join(' ') ||
            undefined
          }
          {...rest}
        />
        <span className={styles.checkmark}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
        {label && <span className={styles.label}>{label}</span>}
      </label>

      {error && (
        <p id={errorId} className={styles.errorText} role="alert">
          {typeof error === 'string' ? error : 'Campo requerido'}
        </p>
      )}
      {!error && helper && (
        <p id={helperId} className={styles.helperText}>
          {helper}
        </p>
      )}
    </div>
  );
}
